import poorcatsnftAbi from "./assets/poorcatsnft.abi.json"

export default {
    // TODO: key here
    infuraKey: "a4b7113b54554d98ac98dad8ee2e570d",
    

    poorcatsnft: {
        // TODO: Update this
        address: "0x671b758BFeCE08a0957B2273f3759D61edea0f09", // UP TO DATE
        abi: poorcatsnftAbi,
    }
};